/* eslint-disable no-redeclare */
import { z } from 'zod';

export const PlateName = z.enum([
  'INITIAL',
  'COVERAGE_DURATION',
  'COVERAGE_URGENCY',
  'ENROLLED_PART_A_AND_PART_B',
  'GENDER_AND_DATE_OF_BIRTH',
  'GENDER',
  'DATE_OF_BIRTH',
  'ZIP_CODE',
  'PERSONAL_INFORMATION',
  'REDIRECT_UNDER_65',
  'REDIRECT_MEDICARE_ADVANTAGE',
  'REDIRECT_MEDICARE_SUPPLEMENT',
  'FLOW_CONVERSION',
  'KIND_OF_MEDICARE_PLAN',
  'DOB_CATEGORY',

  'REDIRECT_ACA_HEALTHCARE_COM',
  'GENDER_DOB_DOB_CATEGORY_HEALTH',
  'COVERAGE_DURATION',
  'CHANGE_PHARMACY_HEALTH',
  'ESTIMATED_SPENDING',
  'ZIP_CODE_HEALTH',
  'HOUSEHOLD_INCOME',
  'HOUSEHOLD_SIZE',
  'HOUSEHOLD_SIZE_INCOME',
  'REDIRECT_TYP_HEALTH',
  'INCOME_SUBSIDY',
  'QUALIFYING_LIFE_EVENT',
  'REDIRECT_STM_HEALTHCARE_COM',
  'INSURE_WHO',
  'REDIRECT_MEDICARE_HEALTHCARE_COM',
  'SPOUSE_CHILDREN',
  'IMMEDIATE_COVERAGE',
  'FNAME_LNAME_EMAIL_LOCATION_PHONE_HEALTH',
  'TOBACCO',
  'SENIOR_CHECK_HEALTH',
  'VISIT_PURPOSE',
  'FIRST_TIME_ENROLLMENT_HEALTH',
  'FIRST_TIME_ENROLLMENT_MEDICARE',

  // Life Insurance unique plates
  'INSURANCE_OPTIONS',
  'MEDICAL_HISTORY',
  'FAMILY_MEDICAL_HISTORY',
  'HEIGHT_WEIGHT',
  'ANNUAL_INCOME',
  'COVERAGE_AMOUNT',
  'EMPLOYMENT_STATUS',
  'HEALTH_ASSESSMENT',
  'REDIRECT_TYP_LIFE',
  'HEALTH_ASSESSMENT',
  'CURRENT_LIFE_INSURANCE',
  'DRIVING_HISTORY',
  'LIFESTYLE_ACTIVITIES',

  // MP-3564 U65 Customer intent series
  'LOOKING_FOR_HELP',
  'LOOKING_FOR_HELP_EXTENSION',
  'EDUCATION_INTERSTITIAL',
]);

export type PlateName = z.infer<typeof PlateName>;
